// LIBRARIES
import axiosInstance from '@/axiosInstance.js';
import { watch } from 'vue';
import pinia from '@/store.js';
import { defineAsyncComponent } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

// STORES
import { useAuthStore } from '@/stores/AuthStore.js';
import { useLoadingMsgStore } from '@/stores/LoadingMsgStore.js';
const authStore = useAuthStore(pinia);
const loadingMsgStore = useLoadingMsgStore(pinia);

const SignIn = () => import('@/views/SignIn.vue');
const Password = () => import('@/views/Password.vue');
const Home = () => import('@/views/Home.vue');
const Docs = () => import('@/views/Docs.vue');
const Members = () => import('@/views/Members.vue');
const Shops = () => import('@/views/Shops.vue');
const NotesHistory = () => import('@/views/NotesHistory.vue');
const VisitationLog = () => import('@/views/VisitationLog.vue');
const Photo = () => import('@/views/Photo.vue');

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/docs',
        name: 'docs',
        component: Docs,
    },
    {
        path: '/members',
        name: 'members',
        component: Members,
    },
    {
        path: '/password',
        name: 'password',
        component: Password,
    },
    {
        path: '/photo',
        name: 'photo',
        component: Photo,
    },
    {
        path: '/signin',
        name: 'signin',
        component: SignIn,
    },
    {
        path: '/shops',
        name: 'shops',
        component: Shops,
    },
    {
        path: '/noteshistory',
        name: 'noteshistory',
        component: NotesHistory,
    },
    {
        path: '/visitationlog',
        name: 'visitationlog',
        component: VisitationLog,
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes,
});

router.beforeEach((to, from, next) => {
    let hasToken = localStorage.getItem('token');

    // console.log('hastoken: ', hasToken)

    // console.log('from: ' + from.name);
    // console.log('to: ' + to.name);

    if (to.name == 'signin' && !hasToken) {
        return next();
    } else if (to.name != 'password' && !hasToken) {
        console.log('sending to signin...');
        return next({
            name: 'signin',
        });
    } else if (
        to.name != 'password'
        // && hasToken
    ) {
        if (typeof from.name != 'undefined' && ['members', 'shops'].includes(to.name)) {
            return next();
        } else {
            if (navigator.onLine) {
                authStore.attempt().then((res) => {
                    if (res) {
                        console.log('auth worked');
                        if (to.name == 'signin') {
                            return next({
                                name: 'home',
                            });
                        } else {
                            return next();
                        }
                    } else {
                        console.log('auth did not work');
                        return next({
                            name: 'signin',
                        });
                    }
                });
            } else {
                return next();
            }
        }
    } else {
        return next();
    }
});

window.addEventListener('online', handleConnection);
window.addEventListener('offline', handleConnection);

if (!navigator.onLine) {
    console.log('offline!');
    handleConnection();
}

function handleConnection() {
    if (navigator.onLine) {
        isReachable(window.location.origin).then(function (online) {
            if (online) {
                // handle online status
                console.log('online');
                setTimeout(() => {
                    console.log('hiding loading message');
                    loadingMsgStore.$patch({
                        offline: false,
                    });
                }, 1000);
                // if(navigator.serviceWorker) {
                //     navigator.serviceWorker.controller.postMessage({ command: 'setCache', name: '/offlinestatus', value: 'false'})
                // }
            } else {
                console.log('no connectivity');
            }
        });
    } else {
        // handle offline status
        console.log('offline');
        loadingMsgStore.$patch({
            offline: true,
        });
        // if(navigator.serviceWorker) {
        //     navigator.serviceWorker.controller.postMessage({ command: 'setCache', name: '/offlinestatus', value: 'true'})
        // }
    }
}

function isReachable(url) {
    /**
     * Note: fetch() still "succeeds" for 404s on subdirectories,
     * which is ok when only testing for domain reachability.
     *
     * Example:
     *   https://google.com/noexist does not throw
     *   https://noexist.com/noexist does throw
     */
    return fetch(url, { method: 'HEAD', mode: 'no-cors' }).then(function (resp) {
        return resp && (resp.ok || resp.type === 'opaque');
    });
    // .catch(function(err) {
    //   // console.warn('[conn test failure]:', err);
    // });
}

export default router;
